export interface ModuleLifeLimit {
  moduleName: string;
  manufacturer: string;
  engineFamily: string;
  maxHours: number | null; // null = "on condition"
  maxCycles: number | null;
  criticalPart?: string;
  notes?: string;
}

export const MODULE_LIFE_LIMITS: ModuleLifeLimit[] = [
  // Pratt & Whitney Canada
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6',
    maxHours: 7500,
    maxCycles: 15000,
    criticalPart: 'Centrifugal compressor impeller',
  },
  {
    moduleName: 'Gas Generator',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6',
    maxHours: null,
    maxCycles: null,
    notes: 'On condition monitoring',
  },
  {
    moduleName: '1st Stage Turbine Disc',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6T',
    maxHours: 1775,
    maxCycles: 3000,
    criticalPart: 'High-pressure turbine disc',
  },
  {
    moduleName: '2nd Stage Turbine Disc',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6T',
    maxHours: 1775,
    maxCycles: 3000,
    criticalPart: 'High-pressure turbine disc',
  },
  
  // Rolls-Royce (Allison)
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series I',
    maxHours: 3550,
    maxCycles: 9150,
    criticalPart: 'Centrifugal compressor',
  },
  {
    moduleName: '1st Stage Turbine',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series I',
    maxHours: 1775,
    maxCycles: 3000,
    criticalPart: 'Gas producer turbine',
  },
  {
    moduleName: '3rd Stage Turbine',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series I',
    maxHours: 4550,
    maxCycles: 4500,
    criticalPart: 'Power turbine',
  },
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series II/III',
    maxHours: 7500,
    maxCycles: 15000,
    criticalPart: '6-stage axial + centrifugal',
  },
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series IV C40B',
    maxHours: 10000,
    maxCycles: 20000,
    criticalPart: 'Enhanced centrifugal compressor',
  },
  
  // Safran (Turbomeca)
  {
    moduleName: 'Axial Wheel',
    manufacturer: 'Safran',
    engineFamily: 'Arrius',
    maxHours: null,
    maxCycles: 22000,
    criticalPart: 'Axial compressor stage',
  },
  {
    moduleName: 'Centrifugal Impeller',
    manufacturer: 'Safran',
    engineFamily: 'Arrius',
    maxHours: null,
    maxCycles: 22000,
    criticalPart: 'Centrifugal compressor',
  },
  {
    moduleName: 'HP Turbine Disc',
    manufacturer: 'Safran',
    engineFamily: 'Arrius',
    maxHours: null,
    maxCycles: 17000,
    criticalPart: 'High-pressure turbine',
  },
  {
    moduleName: 'Power Turbine Disc',
    manufacturer: 'Safran',
    engineFamily: 'Arrius',
    maxHours: null,
    maxCycles: 22000,
    criticalPart: 'Free power turbine',
  },
  {
    moduleName: 'Injection Wheel',
    manufacturer: 'Safran',
    engineFamily: 'Arriel',
    maxHours: null,
    maxCycles: 10000,
    criticalPart: 'Fuel injection system',
  },
  {
    moduleName: 'HP Turbine Disc',
    manufacturer: 'Safran',
    engineFamily: 'Arriel',
    maxHours: null,
    maxCycles: 17000,
    criticalPart: 'Single-stage HP turbine',
  },
  
  // General Electric
  {
    moduleName: 'Compressor Turbine',
    manufacturer: 'General Electric',
    engineFamily: 'T700',
    maxHours: null,
    maxCycles: 6600,
    criticalPart: '2-stage gas producer turbine',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'General Electric',
    engineFamily: 'T700',
    maxHours: null,
    maxCycles: 6600,
    criticalPart: '2-stage free power turbine',
  },
  {
    moduleName: 'Axial Compressor',
    manufacturer: 'General Electric',
    engineFamily: 'T700',
    maxHours: null,
    maxCycles: 6600,
    criticalPart: '5-stage axial compressor',
  },
  
  // Honeywell (Lycoming)
  {
    moduleName: 'Turbine Disc',
    manufacturer: 'Honeywell',
    engineFamily: 'T53',
    maxHours: null,
    maxCycles: 5000,
    criticalPart: '2-stage turbine',
  },
  {
    moduleName: 'Turbine Disc',
    manufacturer: 'Honeywell',
    engineFamily: 'T55',
    maxHours: null,
    maxCycles: 10000,
    criticalPart: 'Heavy-duty turbine',
  },
  
  // Klimov TV3-117
  {
    moduleName: 'HP Turbine',
    manufacturer: 'Klimov',
    engineFamily: 'TV3-117',
    maxHours: null,
    maxCycles: 10000,
    criticalPart: '2-stage HP turbine',
  },
  {
    moduleName: 'Compressor',
    manufacturer: 'Klimov',
    engineFamily: 'TV3-117',
    maxHours: null,
    maxCycles: 20000,
    criticalPart: '12-stage axial compressor',
  },
  
  // Klimov VK-2500
  {
    moduleName: 'HP Turbine Disc',
    manufacturer: 'Klimov',
    engineFamily: 'VK-2500',
    maxHours: null,
    maxCycles: 12000,
    criticalPart: 'High-pressure turbine',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'Klimov',
    engineFamily: 'VK-2500',
    maxHours: null,
    maxCycles: 15000,
    criticalPart: 'Free turbine',
  },
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Klimov',
    engineFamily: 'VK-2500',
    maxHours: null,
    maxCycles: 18000,
    criticalPart: 'Centrifugal compressor',
  },
  {
    moduleName: 'Reduction Gearbox',
    manufacturer: 'Klimov',
    engineFamily: 'VK-2500',
    maxHours: 3500,
    maxCycles: null,
    criticalPart: 'Main gearbox assembly',
  },
  
  // Safran RTM322
  {
    moduleName: 'HP Turbine',
    manufacturer: 'Safran',
    engineFamily: 'RTM322',
    maxHours: null,
    maxCycles: 20000,
    criticalPart: 'Single-stage HP turbine',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'Safran',
    engineFamily: 'RTM322',
    maxHours: null,
    maxCycles: 20000,
    criticalPart: '2-stage power turbine',
  },
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Safran',
    engineFamily: 'RTM322',
    maxHours: null,
    maxCycles: 30000,
    criticalPart: 'Centrifugal compressor',
  },
  {
    moduleName: 'Combustion Chamber',
    manufacturer: 'Safran',
    engineFamily: 'RTM322',
    maxHours: 8000,
    maxCycles: null,
    criticalPart: 'Annular combustor',
  },
  
  // Safran Arrano
  {
    moduleName: 'HP Turbine Disc',
    manufacturer: 'Safran',
    engineFamily: 'Arrano',
    maxHours: null,
    maxCycles: 20000,
    criticalPart: 'High-pressure turbine',
  },
  {
    moduleName: 'Power Turbine Disc',
    manufacturer: 'Safran',
    engineFamily: 'Arrano',
    maxHours: null,
    maxCycles: 25000,
    criticalPart: 'Free power turbine',
  },
  {
    moduleName: 'FADEC/ECU',
    manufacturer: 'Safran',
    engineFamily: 'Arrano',
    maxHours: 15000,
    maxCycles: null,
    criticalPart: 'Full authority digital control',
    notes: 'Software updates may extend life'
  },
  
  // Safran Aneto
  {
    moduleName: 'HP Turbine',
    manufacturer: 'Safran',
    engineFamily: 'Aneto',
    maxHours: null,
    maxCycles: 25000,
    criticalPart: 'Single-stage HP turbine',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'Safran',
    engineFamily: 'Aneto',
    maxHours: null,
    maxCycles: 25000,
    criticalPart: '2-stage power turbine',
  },
  
  // General Electric CT7
  {
    moduleName: 'Gas Producer Turbine',
    manufacturer: 'General Electric',
    engineFamily: 'CT7',
    maxHours: null,
    maxCycles: 8000,
    criticalPart: '2-stage turbine',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'General Electric',
    engineFamily: 'CT7',
    maxHours: null,
    maxCycles: 8000,
    criticalPart: '2-stage free turbine',
  },
  {
    moduleName: 'Axial Compressor',
    manufacturer: 'General Electric',
    engineFamily: 'CT7',
    maxHours: null,
    maxCycles: 15000,
    criticalPart: '14-stage axial/centrifugal',
  },
  {
    moduleName: 'Fuel Control Unit',
    manufacturer: 'General Electric',
    engineFamily: 'CT7',
    maxHours: 6000,
    maxCycles: null,
    criticalPart: 'Hydromechanical FCU',
  },
  
  // Honeywell HTS900
  {
    moduleName: '1st Stage Turbine Disc',
    manufacturer: 'Honeywell',
    engineFamily: 'HTS900',
    maxHours: null,
    maxCycles: 15000,
    criticalPart: 'HP turbine disc',
  },
  {
    moduleName: 'Power Turbine',
    manufacturer: 'Honeywell',
    engineFamily: 'HTS900',
    maxHours: null,
    maxCycles: 20000,
    criticalPart: 'Free turbine assembly',
  },
  
  // Pratt & Whitney PT6B
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6B',
    maxHours: 7500,
    maxCycles: 15000,
    criticalPart: 'Centrifugal compressor',
  },
  {
    moduleName: 'Gas Generator Turbine',
    manufacturer: 'Pratt & Whitney Canada',
    engineFamily: 'PT6B',
    maxHours: null,
    maxCycles: 9000,
    criticalPart: 'Single-stage turbine',
  },
  
  // Rolls-Royce M250 Series II
  {
    moduleName: '1st Stage Turbine',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series II',
    maxHours: 2200,
    maxCycles: 4000,
    criticalPart: 'Gas producer turbine',
  },
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series II',
    maxHours: 7500,
    maxCycles: 15000,
    criticalPart: '6-stage axial + centrifugal',
  },
  
  // Rolls-Royce M250 Series V
  {
    moduleName: 'Compressor Wheel',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series V',
    maxHours: 10000,
    maxCycles: 20000,
    criticalPart: 'Enhanced centrifugal compressor',
  },
  {
    moduleName: 'FADEC Unit',
    manufacturer: 'Rolls-Royce',
    engineFamily: 'M250 Series V',
    maxHours: 12000,
    maxCycles: null,
    criticalPart: 'Digital engine control',
  },
  
  // Safran Makila 2A
  {
    moduleName: 'HP Turbine Module',
    manufacturer: 'Safran',
    engineFamily: 'Makila 2A',
    maxHours: null,
    maxCycles: 12000,
    criticalPart: 'High-pressure turbine',
  },
  {
    moduleName: 'Power Turbine Module',
    manufacturer: 'Safran',
    engineFamily: 'Makila 2A',
    maxHours: null,
    maxCycles: 15000,
    criticalPart: 'Free turbine',
  },
  {
    moduleName: 'Combustion Chamber',
    manufacturer: 'Safran',
    engineFamily: 'Makila 2A',
    maxHours: 6000,
    maxCycles: null,
    criticalPart: 'Reverse-flow combustor',
  },
];

export const getModuleLifeLimit = (
  moduleName: string,
  manufacturer: string,
  engineFamily: string
): ModuleLifeLimit | undefined => {
  return MODULE_LIFE_LIMITS.find(
    (limit) =>
      limit.moduleName === moduleName &&
      limit.manufacturer === manufacturer &&
      limit.engineFamily === engineFamily
  );
};

export const getLifeLimitsByEngine = (
  manufacturer: string,
  engineFamily: string
): ModuleLifeLimit[] => {
  return MODULE_LIFE_LIMITS.filter(
    (limit) =>
      limit.manufacturer === manufacturer &&
      limit.engineFamily === engineFamily
  );
};
